import { publicApiClient } from '@/services/public/publicApiClient'

import type { PublicSiteBundle } from '@/services/public/types'

export async function fetchPublicSiteBundle(): Promise<PublicSiteBundle> {
  const { data } = await publicApiClient.get<PublicSiteBundle>('/api/v1/public/site')
  return data
}
